// Espresso Morning logo: rising sun (three concentric arcs) + editorial wordmark
export const EspressoLogo = ({ size = 36, className = "" }) => (
  <span
    className={`inline-flex items-center gap-3 ${className}`}
    data-testid="espresso-logo"
    aria-label="Espresso Morning"
  >
    <svg
      width={size}
      height={size}
      viewBox="0 0 48 48"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      aria-hidden="true"
    >
      <line x1="4" y1="36" x2="44" y2="36" stroke="#C05A44" strokeWidth="1.5" />
      <path d="M 12 36 A 12 12 0 0 1 36 36" fill="none" stroke="#C05A44" strokeWidth="1.5" />
      <path d="M 17 36 A 7 7 0 0 1 31 36" fill="none" stroke="#C05A44" strokeWidth="1.5" />
      <circle cx="24" cy="36" r="3" fill="#C05A44" />
    </svg>
    <span className="flex flex-col leading-none">
      <span
        className="font-display font-semibold uppercase"
        style={{
          fontFamily: "'Playfair Display', serif",
          letterSpacing: "0.18em",
          fontSize: "1.05rem",
          color: "var(--em-text)",
        }}
      >
        Espresso
      </span>
      <span
        style={{
          fontFamily: "'Inter', sans-serif",
          letterSpacing: "0.32em",
          fontSize: "0.6rem",
          color: "var(--em-text-muted)",
          marginTop: "2px",
        }}
      >
        MORNING
      </span>
    </span>
  </span>
);

export default EspressoLogo;
